import axios from 'axios';

// const configLocal = localStorage.getItem('configColetor');
// const baseURL = configLocal ? JSON.parse(configLocal).host : '';

// Adicionado para fins de testes pois a API do Syclus não está aceitando HTTPS
// e isso faz as requisições falharem baseURL: 'https://coletor-syclus.netlify.app/api'
const api = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  headers: {
    'app-key': process.env.VUE_APP_APP_KEY
  }
});

export default api;